import type { Bundle } from '../types'

/** Contrôles de traitement d'une détection : statut, prise en charge, journal. */
export const triage = {
  'triage.changeStatus': { fr: 'Changer le statut de traitement', en: 'Change the triage status' },
  'triage.handle': { fr: 'Traiter…', en: 'Triage…' },
  'triage.assignedBy': { fr: 'Prise en charge par {who}', en: 'Taken on by {who}' },
  'triage.release': { fr: 'Relâcher', en: 'Release' },
  'triage.takeCharge': { fr: 'Prendre en charge', en: 'Take charge' },
  'triage.history': { fr: 'Historique', en: 'History' },
  'triage.historyTitle': { fr: 'Historique de traitement', en: 'Triage history' },
  'triage.historyEmpty': {
    fr: 'Aucune action enregistrée sur cette détection.',
    en: 'No action recorded on this detection.',
  },
  'triage.reasonRequired': { fr: 'Motif (obligatoire)', en: 'Reason (required)' },
  'triage.reasonOptional': { fr: 'Motif (facultatif)', en: 'Reason (optional)' },
  'triage.reasonPlaceholderRequired': {
    fr: 'Ce motif sera conservé dans la piste d’audit.',
    en: 'This reason is kept in the audit trail.',
  },
  'triage.reasonPlaceholderOptional': { fr: 'Précision facultative.', en: 'Optional detail.' },
  'triage.bulkTitle': { fr: 'Traitement en masse', en: 'Bulk triage' },
} satisfies Bundle
